// extracted by mini-css-extract-plugin
export default {"line":"ZTtoeTrAmf"};